export default "__VITE_ASSET__3968d5fb__"